<template>
  <NotificationPopup
    id="last-notification-popup"
    ref="notificationPopup"
    placement="right-end"
    :class="clsx('notification-popup', { enter: animationState === 'enter', leave: animationState === 'leave' })"
  >
    <div class="notification">
      <p class="notification__title">
        {{ truncateString(getNotification.title, 200) }}
        <span class="notification__date">{{ formatDateTime(getNotification.created_at, 'YYYY-MM-DD HH:mm') }}</span>
      </p>
      <p>{{ truncateString(getNotification.message, 300) }}</p>
    </div>
  </NotificationPopup>
</template>

<script>
import clsx from 'clsx';
import { mapGetters } from 'vuex';
import { LAST_UNREAD_MESSAGE_POPUP_EVENTS } from '../../config';
import { dateTimeFormatter } from '@/shared/lib/date-time';
import { truncateString } from '@/shared/lib/string';
import { NotificationPopup } from '@/shared/ui/popup';

export default {
  data() {
    return {
      animationState: 'enter',
    };
  },
  mixins: [ truncateString, dateTimeFormatter ],
  components: { NotificationPopup },
  created() {
    this.$eventBus.$on(
      LAST_UNREAD_MESSAGE_POPUP_EVENTS.LAST_UNREAD_MESSAGE_POPUP_CLOSE, () => this.closeWithAnimation());
  },
  beforeDestroy() {
    this.$eventBus.$off(
      LAST_UNREAD_MESSAGE_POPUP_EVENTS.LAST_UNREAD_MESSAGE_POPUP_CLOSE, () => this.closeWithAnimation());
  },
  computed: {
    ...mapGetters('serverNotificationsModule', ['getLastUnreadNotification', 'isNotificationsDataReady']),
    ...mapGetters('layoutModule', ['isTablet', 'isMobile']),
    getNotification() {
      const notification = this.getLastUnreadNotification;
      return notification || '';
    },
  },
  methods: {
    clsx,
    openWithAnimation() {
      this.animationState = 'enter';
      this.$refs.notificationPopup.openPopup();

      setTimeout(() => {
        if (this.isTablet || this.isMobile) {
          this.closeWithAnimation();
        }
      }, 10000);
    },
    closeWithAnimation() {
      this.animationState = 'leave';

      setTimeout(() => {
        this.$refs.notificationPopup.closePopup(
          this.$refs.notificationPopup.getPopupId
        );
      }, 1000);
    },
  },
  watch: {
    isNotificationsDataReady: {
      immediate: false,
      handler(ready) {
        if (ready && this.getLastUnreadNotification && !this.disable) {
          this.openWithAnimation();
        }
      },
    },
    getLastUnreadNotification: {
      immediate: false,
      handler() {
        if (this.getLastUnreadNotification && !this.disable) {
          this.openWithAnimation();
        }
      },
    },
  }
};
</script>

<style scoped lang="scss">
.notification {
  position: relative;
  background-color: #FB923C;
  color: #020617;
  border-radius: 4px;
  padding: 8px;
  margin-right: 28px;

  @media (max-width: 1050px) {
    margin-right: 39px;
  }

  @media (max-width: 1050px) {
    margin-right: 48px;
  }

  &:after {
    content: '';
    position: absolute;
    width: 45px;
    height: 45px;
    top: 7px;
    right: -20px;
    background-color: #FB923C;
    border-radius: 8px;
    transform: rotate(45deg);
    z-index: -1;

    @media (max-width: 1050px) {
      content: none;
    }
  }

  &-popup {
    opacity: 1;
    transform: translateX(0);
  }

  &__title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: 500;
  }

  &__date {
    text-align: right;
    font-size: 12px;
    font-weight: 400;
    text-wrap: nowrap;
  }

  p {
    margin-bottom: 0;
  }
}

.enter {
  animation: slideIn 1s ease;

  @media (max-width: 1050px) {
    animation: slideDownIn 1s ease;
  }
}

.leave {
  animation: slideOut 1s ease;

  @media (max-width: 1050px) {
    animation: slideDownOut 1s ease;
  }
}

.enter-down {
  animation: slideDownIn 1s ease forwards;
}

.leave-down {
  animation: slideDownOut 1s ease forwards;
}

@keyframes slideIn {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes slideOut {
  from {
    transform: translateX(0);
    opacity: 1;
  }
  to {
    transform: translateX(100%);
    opacity: 0;
  }
}

@keyframes slideDownIn {
  from {
    transform: translateY(-100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes slideDownOut {
  from {
    transform: translateY(0);
    opacity: 1;
  }
  to {
    transform: translateY(-100%);
    opacity: 0;
  }
}
</style>
